import { cx } from '@flowus/common/cx';
import type { CSSProperties, FC } from 'react';
import { IconTrigger } from 'src/components/icon-trigger';
import { useBlock } from 'src/hooks/block/use-block';
import type { ReadonlyProp } from 'src/redux/types';

export const Callout: FC<
  {
    id: string;
    onChange?(emoji: string): void;
    style?: CSSProperties;
    className?: string;
    iconClassName?: string;
    childrenClassName?: string;
  } & ReadonlyProp
> = (props) => {
  const block = useBlock(props.id);
  const icon = block?.data.icon;
  return (
    <div className={cx('flex items-start py-3 px-4', props.className)} style={props.style}>
      {icon?.value && (
        <IconTrigger
          blockId={props.id}
          className={cx('mt-1', props.iconClassName)}
          hideRemoveBtn={false}
          trigger={!props.readonly}
          iconSize={20}
          // defaultEmoji={'💡'}
          onSelectEmoji={(emoji) => {
            if (props.onChange) props.onChange(emoji);
          }}
        />
      )}
      <div className={cx('w-[calc(100%-36px)] ml-2', props.childrenClassName)}>
        {props.children}
      </div>
    </div>
  );
};
